import { getInitialStateFromConfig } from "helpers/form";
import { requiredField } from "helpers/validators";

const config = {
    name: {
        // field
        label: "Название",
        inputProps: { name: "name" },
        validators: [requiredField],
        required: true,
    },
    geozone: {
        // field
        label: "Адрес",
        inputProps: { name: "geozone" },
        validators: [requiredField],
        required: true,
    },
};

const initialState = getInitialStateFromConfig(config);

export { config, initialState };
